exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".container--2IwPi{background-color:#a852c5;position:absolute;opacity:.8;width:100%;top:0;left:0;padding:7px;color:#fff;text-align:center;z-index:1000}", "", {"version":3,"sources":["/workspace/src/widget/premium_feature_banner/style.scss"],"names":[],"mappings":"AAAA,kBACE,yBAAyB,AACzB,kBAAkB,AAClB,WAAY,AACZ,WAAW,AACX,MAAM,AACN,OAAO,AACP,YAAY,AACZ,WAAY,AACZ,kBAAkB,AAClB,YAAa,CACd","file":"style.scss","sourcesContent":[".container {\n  background-color: #a852c5;\n  position: absolute;\n  opacity: 0.8;\n  width: 100%;\n  top: 0;\n  left: 0;\n  padding: 7px;\n  color: white;\n  text-align: center;\n  z-index: 1000;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"container": "container--2IwPi"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--4-1!./node_modules/postcss-loader/lib??ref--4-2!./node_modules/sass-loader/lib/loader.js??ref--4-3!./src/widget/premium_feature_banner/style.scss
// module id = 1447
// module chunks = 0